import calculateTotalSavings from "../../components/moneyBuilder/savings/objects/calculate_total_savings";
import { calcMonthlyIncome } from "./calcMonthlyIncome";
import { calculateMoodRetirementScores }
     from "../../components/game-views/objects/calculate_mood_retirement_scores";
import checkForInvestmentMix from "./check_for_investment_mix";
import calculateExpenseAmtByType from "../AssetsExpenses/calculate_expense_amt_by_type";


export const determineAchievementAmt = (dataName, currentCash, savingsInfo, creditCardBalance,
                summaryInvestments, investmentMaster, assetTable, expenseTable, loanTable, nbrMonthsPlayed, 
                gameNbrMonths, creditScore, currentGameDate, currentMoodPoints,  
                badgesEarned, moneyMgmtTestArr, pctBase) => {
// G-3 doesn't work - it is a combination of credit card balance and net income... may want to change criteria...?
// G-1 doesn't work - "investmentMix"....   should be able to make this one work with some logic change.
// G-4 doesn't work - "fixedExpenses"... need to create a function that calculates fixed expenses
// P-3 doesn't work - "netWorth" ... need to create a function that accurately calculates net worth...OR...
//        replace this with something else
    let checkAmount = 0;
    let additionalText = "";
    switch (dataName){
        case "currentCash":
            checkAmount = currentCash;
            break;
        case "creditCardBalance":
            checkAmount = creditCardBalance;
            break;
        case "investments":
            const investObj = summaryInvestments.find(elem => elem.investType === "all");
            if (investObj){
                checkAmount = investObj.currentValue;
            }else{
                checkAmount = "N/A";
            }
            break;
        case "investmentDiverse":
        case "investmentMix":
            const mixedObj = checkForInvestmentMix(investmentMaster, dataName);
            checkAmount = mixedObj.numberOfInvests;
            additionalText = mixedObj.additionalText;
            break;
        case "netIncome":
            checkAmount = calcMonthlyIncome(assetTable, expenseTable, loanTable).income;
            break;
        case "bankSavings":
            if (savingsInfo.savingsArr){
                checkAmount = calculateTotalSavings(savingsInfo.savingsArr, 0, "bank").totalSavings;
            }
            let bankSavingsExists = false;
            if (savingsInfo.gameID){
                const savingsCheck = savingsInfo.savingsArr.find(elem => elem.savingsClass === "bank");
                if (savingsCheck){
                    bankSavingsExists = true;
                }
            }
            if (bankSavingsExists === false){
                checkAmount = "N/A";
            }
            break;
        case "retirementSavings":
            if (savingsInfo.savingsArr){
                checkAmount = 
                    calculateTotalSavings(savingsInfo.savingsArr, gameNbrMonths, "retirement").totalSavings;
            }
            let retirementSavingsExists = false;
            if (savingsInfo.gameID){
                const savingsCheck = savingsInfo.savingsArr.find(elem => elem.savingsClass === "retirement");
                if (savingsCheck){
                    retirementSavingsExists = true;
                }
            }
            if (retirementSavingsExists === false){
                checkAmount = "N/A";
            }
            break;
        case "creditScore":
            checkAmount = creditScore;
            break;
        case "totalDebt":
            const loanAmount = calcMonthlyIncome(assetTable, expenseTable, loanTable).loans;
            if (creditCardBalance === "N/A"){
                checkAmount = "N/A";
            }else{
                checkAmount = +creditCardBalance + +loanAmount;
            }
            break;
        case "moodScore":
        case "retirementScore":
            let totalInvestments = 0;
            if (summaryInvestments.length > 0){
                totalInvestments = summaryInvestments.find(elem => elem.investType === "all").currentValue;
            }
            const gameScores = calculateMoodRetirementScores(currentMoodPoints,
                currentCash, savingsInfo.totalSavingsAmt, totalInvestments,
                assetTable, currentGameDate);
            if (dataName === "retirementScore"){
                checkAmount = gameScores.retirementScore;
            }else{
                checkAmount = gameScores.moodScore;
            }
            break;
        case "netWorth":
            // create a function that calculates netWorth
            break;
        case "allBadges":
            checkAmount = (badgesEarned.length / 2).toFixed(1);
            break;
        case "moneyMgmtTest":
            for (let i=0; i<moneyMgmtTestArr.length; i++){
                if (+moneyMgmtTestArr[i].pctCorrect > checkAmount){
                    checkAmount = +moneyMgmtTestArr[i].pctCorrect;
                }
            }
            break;
        default: 
            break;
    }
    let pctBaseAmt = "N/A";
    if (pctBase){
        switch(pctBase){
            case "expenses":
                pctBaseAmt = calculateExpenseAmtByType(expenseTable, "ALL");
                break;
            case "annualSalary":
                pctBaseAmt = calcMonthlyIncome(assetTable, expenseTable, loanTable).assets;
                pctBaseAmt = (+pctBaseAmt * 12).toFixed(2);
                break;
            case "grossIncome":
                pctBaseAmt = calcMonthlyIncome(assetTable, expenseTable, loanTable).assets;
                break;
            default: 
                break;
        }
    }
    const returnObj = {checkAmount: checkAmount, additionalText: additionalText, pctBaseAmt: pctBaseAmt};
    return returnObj;
}
export default determineAchievementAmt;